//---- components ---------
//---- mixins -------------
//---- services -----------
import { ajaxService } from '@/app/services';
//---- other --------------
import CustomUrls from '../../common/CustomUrls.js';
//---- 3rd-parties --------

class AdvisorCustomService {
  getGeoLocalizationInformation() {
    alert('geolocalization requires custom implementation')
    return ajaxService.get(CustomUrls.ipApiUrl)
  }
}
export default new AdvisorCustomService();